<template>
  <v-tooltip left color="surface_neutral_selected">
    <template v-slot:activator="{ on, attrs }">
      <div
          class="card-action-box"
          @click="downloadQRCode"
          v-bind="attrs"
          v-on="on"
          :class="{ 'disabled': !hasQRCode || isDownloading }"
       role="button" aria-label="Baixar QR Code">
        <v-icon>mdi-qrcode</v-icon>
      </div>
    </template>
    <span>Baixar QR Code</span>
  </v-tooltip>
</template>

<script>
import { apiClient } from "@/services/api";

export default {
  name: 'DownloadEnqueteQRCODE',

  props: {
    item: {
      type: Object,
      required: true
    },

  },

  data() {
    return {
      isDownloading: false
    };
  },

  computed: {
    hasQRCode() {
      return this.item?.enquete_qr_code?.url &&
          this.item.enquete_qr_code.url.trim() !== '';
    }
  },

  methods: {
    async downloadQRCode() {
      if (!this.hasQRCode) {
        this.$toast.warning('QR Code não disponível para esta enquete');
        return;
      }

      this.isDownloading = true;

      try {
        const response = await apiClient.get(
            `/enquetes/${this.item.id}/qrcode/download`,
            {
              responseType: 'blob',
              timeout: 30000
            }
        );

        const sanitizedTitle = this.item.dsc_titulo_enquete
            .replace(/[^a-z0-9]/gi, '_')
            .toLowerCase();
        const filename = `${sanitizedTitle}.png`;

        const blob = new Blob([response.data], { type: 'image/png' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        this.$toast.success('QR Code baixado com sucesso');
      } catch (error) {
        const errorMessage = error.response?.data?.error ||
            'Não foi possível baixar o QR Code';
        this.$toast.error(errorMessage);

        console.error('QR Code Download Error:', error);
      } finally {
        this.isDownloading = false;
      }
    }

  }
};
</script>

<style scoped lang="scss">

</style>
